(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/pix-mix/components/services/assets/javascripts/fetch-draws.js') >= 0) return;  svs.modules.push('/modules/pix-mix/components/services/assets/javascripts/fetch-draws.js');
"use strict";

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

const {
  fetchOpenDraws
} = svs.components.lbUtils.apiProxy.openDraws;
const {
  getSpecificDrawName,
  resolveProductId
} = svs.utils.products;
const logger = new svs.core.log.Logger('svs.pix_mix.Pixmixen');
const normalizeDraw = function () {
  var _resolveProductId;
  let draw = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return _objectSpread(_objectSpread({}, draw), {}, {
    productId: (_resolveProductId = resolveProductId(draw.productId)) !== null && _resolveProductId !== void 0 ? _resolveProductId : draw.productId
  });
};

function fetchDraws(successCallback, errorCallback) {
  const run = async () => {
    var _svs;
    const products = [];

    (((_svs = svs) === null || _svs === void 0 || (_svs = _svs.cmsData) === null || _svs === void 0 || (_svs = _svs.data) === null || _svs === void 0 || (_svs = _svs.config) === null || _svs === void 0 ? void 0 : _svs.pixmix) || []).forEach(bundle => {
      var _bundle$products;
      bundle === null || bundle === void 0 || (_bundle$products = bundle.products) === null || _bundle$products === void 0 || _bundle$products.forEach(product => {
        const drawName = getSpecificDrawName(product.id);
        if (!products.includes(drawName)) {
          products.push(drawName);
        }
      });
    });
    try {
      const draws = await fetchOpenDraws({
        products
      });
      successCallback(draws.map(normalizeDraw));
    } catch (error) {
      var _error$responseJSON, _error$responseJSON2;
      const errorMessage = (error === null || error === void 0 || (_error$responseJSON = error.responseJSON) === null || _error$responseJSON === void 0 ? void 0 : _error$responseJSON.message) || (error === null || error === void 0 ? void 0 : error.message) || 'Unknown error';
      const errorCode = (error === null || error === void 0 || (_error$responseJSON2 = error.responseJSON) === null || _error$responseJSON2 === void 0 ? void 0 : _error$responseJSON2.code) || (error === null || error === void 0 ? void 0 : error.status) || 'unknown';
      logger.info("fetchDraws failed message: ".concat(errorMessage, " code: ").concat(errorCode));
      errorCallback(error);
    }
  };
  run();
}
setGlobal('svs.pix_mix.components.services', {
  fetchDraws
});

 })(window);